export function SingleCorp() {
  // console.log("entre acaaaaaaaaaaaaaaaaaaaaaa")
  return "/";
}
